export const ENDPOINTS = {
    CONTACT_FORM: process.env.REACT_APP_SERVICE_ENDPOINT_CONTACT_US, // Replace with your actual endpoint
    // PUBLIC_BLOCKCHAIN_DETAILS: `https://catenaa-jv-apim-dev.azure-api.net/bc/api/RegistrationManagement/verify-block-chain`
    PUBLIC_BLOCKCHAIN_DETAILS: process.env.REACT_APP_SERVICE_ENDPOINT_BLOCKCHAIN
};

export const ALLOWED_HOSTS = [
  "elystrion.com",
  "www.elystrion.com",
  "localhost",
  "127.0.0.1",
];

export const isAllowedRedirectHost = (hostname) => {
  if (!hostname) return false;
  if (ALLOWED_HOSTS.includes(hostname)) return true;
  if (typeof window !== "undefined" && hostname === window.location.hostname) return true;
  // Allow any Elystrion subdomain (e.g. verify.elystrion.com, app.elystrion.com)
  if (hostname === "elystrion.com" || hostname.endsWith(".elystrion.com")) return true;
  return false;
};